import TelemetryProvider from './TelemetryProvider'
import { DataCollectionConsumer } from '@eggplant/context'
import type { ReactElement } from 'react'

interface Props {
  children: ReactElement
}

const Telemetry = ({
  children
}: Props) => {
  const token = import.meta.env.VITE_PUBLIC_POSTHOG_KEY
  const host = import.meta.env.VITE_PUBLIC_POSTHOG_HOST
  const isPostHogEnabled = !!token && !!host
  const isTelemetryDisabled = import.meta.env.VITE_IS_TELEMETRY_DISABLED === 'true'

  return (
    <DataCollectionConsumer>
      {
        ({
          isUserReportingEnabled,
          isDataCollectionAllowed
        }) => {
          if (!isPostHogEnabled) return children

          return isUserReportingEnabled && isDataCollectionAllowed && !isTelemetryDisabled
            ? (
              <TelemetryProvider
                host={host}
                token={token}
              >
                {children}
              </TelemetryProvider>
            )
            : children
        }
      }
    </DataCollectionConsumer>
  )
}

export default Telemetry
